// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__Mueg-","container":"App_container__OWuZG"};